// src/hooks/usePageTracking.js
// React Router hook to automatically track page views

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import pageAnalyticsService from '../services/pageAnalyticsService';

/**
 * Hook to automatically track page views when route changes
 * Usage: Add <PageTracker /> to your app or call usePageTracking() in each route component
 */
export const usePageTracking = (pageName = null, module = null) => {
  const location = useLocation();

  useEffect(() => {
    // Track page view on mount and when location changes
    const pagePath = location.pathname;
    pageAnalyticsService.trackPageView(pagePath, pageName, module);

    // Cleanup when component unmounts
    return () => {
      pageAnalyticsService.cleanup();
    };
  }, [location.pathname, pageName, module]);
};

/**
 * Component wrapper for automatic page tracking
 */
export const PageTracker = ({ pageName = null, module = null }) => {
  usePageTracking(pageName, module);
  return null;
};

export default usePageTracking;







